import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Grid, Tooltip, Button, Checkbox } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import Utils from "../../utils/utils";
import { headers } from "./models";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnCheckBox: {
    flexBasis: "10%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));

//style={{ color: data.checked ? 'gray' : 'white' }}

export default function AccordionNotification({
  data,
  setNotificationChecked,
  notificationChecked,
  setCardData,
  hasChange,
}) {
  const classes = useStyles();
  const id = IdKey.generate();
  const [checked, setChecked] = useState(false);

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }

        if (
          object.type === "requisition" &&
          header.field === "employeeFullName"
        ) {
          return "";
        }

        if (header.field === "notificationDate") {
          let fechaInicial = object[header.field];

          var initDate = fechaInicial ? fechaInicial.split("T")[0] : null;
          return moment(initDate).format("DD/MM/YYYY");
        }

        if (header.field === "message") {
          let mensaje = object[header.field];
          if (mensaje) {
            let message =
              mensaje.length > 50 ? mensaje.substr(0, 50) + " ..." : mensaje;

            return message;
          }
        }

        return object[header.field];
      }

      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  const onChangeNotification = (e) => {
    e.preventDefault();
    const { checked } = e.target;
    setChecked(checked);
    data.defaultChecked = checked;
    const isChecked = notificationChecked.indexOf(data.id);

    if (checked && isChecked === -1) {
      setNotificationChecked((anterior) => [...anterior, data.id]);
      // } else if (checked && isChecked !== -1) {
    } else {
      setNotificationChecked(
        notificationChecked.filter((item) => item !== data.id)
      );
    }
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
          backgroundColor: data.checked ? "#ffffff" : "#e1e1e1",
        }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          // expandIcon={<ExpandMoreIcon />}
        >
          <div className={classes.columnCheckBox}>
            <Checkbox
              color="primary"
              name={`checkBox`}
              defaultChecked={data.defaultChecked}
              checked={data.defaultChecked}
              inputProps={{ "aria-label": "secondary checkbox" }}
              onChange={(event) => onChangeNotification(event)}
            />
          </div>
          {headers.initialHeaders.map((header) =>
            header.field === "employeeFullName" &&
            data.notificationType === "Requisiciones" ? (
              ""
            ) : header.field === "message" &&
              (data.notificationType === "Cumpleaños" ||
                data.notificationType === "Contratos" ||
                data.notificationType === "Licencia Maternidad" ||
                data.notificationType === "Recomendaciones AT") ? (
              ""
            ) : (
              <div className={classes.column} onClick={() => setCardData(data)}>
                <Typography className={classes.heading}>
                  {header.title}
                </Typography>
                <Typography className={classes.secondaryHeading}>
                  {getValueByKey(data, header)}
                </Typography>
              </div>
            )
          )}
        </FlippedOrderExpansionPanelSummary>
      </Accordion>
    </div>
  );
}
